






























































import { computed, defineComponent, toRefs } from '@nuxtjs/composition-api'
import CTransitionExpand from '~/components/shared/configurable/expand/CTransitionExpand.vue'
import Field from '~/components/car/classifieds/form/fieldsets/fields/Field.vue'
import { CLASSIFIED_FORM_NS } from '~/store/modules/shared/classifieds/form/state'
import { useNamespacedStore } from '~/compositions/store'
import { useDep } from '~/compositions/dependency-container'
import FormComponentService from '~/services/form/FormComponentService'
import { Field as FieldType } from '~/models/form/types'

export default defineComponent({
  components: {
    CTransitionExpand,
    Field
  },
  props: {
    labelColumns: {
      type: Number,
      default: 4
    },
    fieldsColumns: {
      type: Number,
      default: 8
    },
    fields: {
      type: Array,
      default() {
        return []
      }
    },
    name: {
      type: String,
      required: true
    },
    extras: {
      type: Object,
      required: false,
      default() {
        return {}
      }
    }
  },
  setup(props) {
    const { name, fields } = toRefs(props)
    const { state } = useNamespacedStore(CLASSIFIED_FORM_NS)
    const pageKey = computed(() => state.pageKey)
    const formComponentService = useDep(FormComponentService)

    const fieldGroups = computed(() => {
      const fieldsToGroup = formComponentService.getGroupFieldsForFieldset(
        name.value,
        state.categoryIds
      )

      if (fieldsToGroup.length && fields.value) {
        return fields.value.reduce((acc, f) => {
          const fieldsGroup = fieldsToGroup.find(ftg =>
            ftg.fieldNames.includes(f.name)
          )
          const shouldBeGrouped =
            fieldsGroup?.fieldNames.some(name => name === f.name) || false

          if (
            shouldBeGrouped &&
            (acc.length === 0 ||
              acc[acc.length - 1].type !== 'group' ||
              (acc[acc.length - 1] &&
                acc[acc.length - 1].type === 'group' &&
                !acc[acc.length - 1].fields.some(fld =>
                  fieldsGroup.fieldNames.includes(fld.name)
                )))
          ) {
            // add new group if zero length or last type was not group or last group-type doesnt have any associated fields
            acc.push({
              type: 'group',
              fields: [],
              groupColumns: fieldsGroup.groupColumns,
              fieldsColumns: fieldsGroup.fieldsColumns,
              groupRowClasses: fieldsGroup.groupRowClasses,
              groupLabel: fieldsGroup.groupLabel
            })
          } else if (
            !shouldBeGrouped &&
            (acc.length === 0 || acc[acc.length - 1].type !== 'fields')
          ) {
            acc.push({ type: 'fields', fields: [] })
          }

          const lastIndexOfTypeReversed = [...acc].reverse().findIndex(a => {
            if (shouldBeGrouped) {
              return a.type === 'group'
            }
            return a.type === 'fields'
          })

          const lastIndexOfType = acc.length - 1 - lastIndexOfTypeReversed

          acc[
            lastIndexOfType > -1 ? lastIndexOfType : acc.length - 1
          ].fields.push(f)

          return acc
        }, [])
      }
      return fields.value?.length
        ? [{ type: 'fields', fields: fields.value }]
        : []
    })

    const getFieldBindings = (field: FieldType) => {
      return {
        type: field.type,
        name: field.name,
        disabled: field.disabled,
        humanName: field.humanName,
        specs: field.specs,
        required: field.required,
        suggestions: field.suggestions
      }
    }

    return {
      pageKey,
      fieldGroups,
      getFieldBindings
    }
  }
})
